export default __webpack_public_path__ + "static/media/zoomcar.edc283b2.png";